<script lang="ts" module>
	export type MediaCardVariant = 'dark' | 'light';

	export interface MediaCardProps {
		dataCy: string;
		src?: string;
		alt?: string;
		href?: string;
		onclick?: () => void;
		loading?: boolean;
		/** Load the image eagerly at high priority, for a card that is above the fold. */
		priority?: boolean;
		/** `sizes` for the image's srcset; defaults to full width on a phone, half from md. */
		sizes?: string;
		forceHorizontalOnMobile?: boolean | undefined;
		variant?: MediaCardVariant;
		class?: string;
		imageOverlay?: import('svelte').Snippet;
		title?: import('svelte').Snippet;
		description?: import('svelte').Snippet;
		classes?: {
			imageContainerClass?: string;
			textContainerClass?: string;
		};
	}
</script>

<script lang="ts">
	import { Link } from '../Link';
	import { MediaCardContent } from './MediaCardContent';

	let { dataCy, href = undefined, onclick = undefined, ...rest }: MediaCardProps = $props();

	let dataCyPrefix = $derived(`${dataCy}-media-card`);
</script>

<Link {href} data-cy={dataCyPrefix} class={rest.class} {onclick}>
	<MediaCardContent {dataCy} {...rest} class={undefined} />
</Link>
